// @ts-ignore
import { createRequestActionNames } from 'helpers'

export const ORGANIZATIONS_FETCH_ALL_REQUEST = 'ORGANIZATIONS/FETCH_ALL_REQUEST'
export const ORGANIZATIONS_FETCH_ALL_SUCCESS = 'ORGANIZATIONS/FETCH_ALL_SUCCESS'

export const ORGANIZATIONS_CHECK_DOMAIN_REQUEST = 'ORGANIZATIONS/CHECK_DOMAIN_REQUEST'

export const ORGANIZATIONS_UPLOAD_LOGO_REQUEST = 'ORGANIZATIONS/UPLOAD_LOGO_REQUEST'
export const ORGANIZATIONS_UPLOAD_LOGO_SUCCESS = 'ORGANIZATIONS/UPLOAD_LOGO_SUCCESS'
export const ORGANIZATIONS_UPLOAD_LOGO_ERROR = 'ORGANIZATIONS/UPLOAD_LOGO_ERROR'

export const ORGANIZATIONS_SELECT_PAGE = 'ORGANIZATIONS/SELECT_PAGE'
export const ORGANIZATIONS_SORT_BY = 'ORGANIZATIONS/SORT_BY'
export const ORGANIZATIONS_FILTER_BY = 'ORGANIZATIONS/FILTER_BY'

export const ORGANIZATIONS_USERS_SELECT_PAGE = 'ORGANIZATIONS/USERS_SELECT_PAGE'
export const ORGANIZATIONS_USERS_SORT_BY = 'ORGANIZATIONS/USERS_SORT_BY'
export const ORGANIZATIONS_USERS_FILTER_BY = 'ORGANIZATIONS/USERS_FILTER_BY'
export const ORGANIZATIONS_USERS_FILTER_BY_TEAM = 'ORGANIZATIONS/USERS_FILTER_BY_TEAM'

export const ORGANIZATIONS_USERS_SWITCH_TAB = 'ORGANIZATIONS/USERS_SWITCH_TAB'
export const ORGANIZATIONS_SELECT_USERS_ORGANIZATION = 'ORGANIZATIONS/SELECT_USERS_ORGANIZATION'

export const ORGANIZATIONS_FORM_SET_FORM_TYPE = 'ORGANIZATIONS/FORM/SET_FORM_TYPE'

export const ORGANIZATIONS_REMOTE_FORM_SUBMIT = 'ORGANIZATIONS/REMOTE_SUBMIT_FORM'

export const ORGANIZATIONS_FORM_DISABLE = 'ORGANIZATIONS/FORM_DISABLE'
export const ORGANIZATIONS_FORM_ENABLE = 'ORGANIZATIONS/FORM_ENABLE'

export const ORGANIZATIONS_USERS_SELECT_FIRST_ORGANIZATION = 'ORGANIZATIONS/USERS_SELECT_FIRST_ORGANIZATION'

export const INVITES = createRequestActionNames('INVITES', ['POST'])
export const INVITES_FORM_SUBMIT = 'INVITES/FORM_SUBMIT'

export const ADMIN_ORGANIZATION_USERS = createRequestActionNames('ADMIN_ORGANIZATION_USERS', ['GET', 'POST'])
export const ADMIN_ORGANIZATION_USERS_RESEND_INVITE = createRequestActionNames(
  'ADMIN_ORGANIZATION_USERS_RESEND_INVITE',
  ['POST']
)

export const ORGANIZATION_SET_PENDING_GET_ORGANIZATION_USERS = 'ORGANIZATION/SET_PENDING_GET_ORGANIZATION_USERS'

export const ORGANIZATIONS_SET_PENDING_OBJECT = 'ORGANIZATIONS/SET_PENDING_OBJECT'

export const ORGANIZATION_SET_REVIEWS_SURVEY_ID = 'ORGANIZATION/SET_REVIEWS_SURVEY_ID'

export const ORGANIZATION_SET_API_KEY_AND_EMAIL_FROM = 'ORGANIZATION/SET_API_KEY_AND_EMAIL_FROM'

export const ORGANIZATION_UPDATE_API_KEY_AND_EMAIL_FROM = 'ORGANIZATION/UPDATE_API_KEY_AND_EMAIL_FROM'
